import { axiosInstance } from '../request';
export const getSettings = async () => {
    const response = await axiosInstance.get('/api/v1/settings');
    return response.data;
};
export const updateChatbotSettings = async (data) => {
    await axiosInstance.patch('/api/v1/settings', data);
};
export const updateMcpBotSettings = async (data) => {
    await axiosInstance.patch('/api/v1/settings', {
        mcp_bot: data
    });
};
export const updateMemoryNotesSettings = async (data) => {
    await axiosInstance.patch('/api/v1/settings', {
        memory_notes: data
    });
};
//# sourceMappingURL=settings.api.js.map